import { useSelector, useDispatch } from 'react-redux';
import {
    deletePlace,
    startAddingPlace,
    closePlaceDialog,
    setPlaceActiveTab,
    closeDeletingDialog,
    getActivePlace,
    getPlaceDialogState,
    getPlaceDeleteState,
} from '../../store/slices/placesSlice';
import { useTranslation } from 'react-i18next';
import settings from '../../config.json';
import { tokens } from '../../theme';
import { Box, Dialog, Tab, useTheme } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import useMediaQuery from '../../hooks/useMediaQuery';
import usePermission from '../../hooks/usePermission';
import TableHeader from '../../components/table/TableHeader';
import GridPlaces from './GridPlaces';
import FormPlace from './FormPlace';
import ConfirmActionDialog from '../../components/dialogs/ConfirmActionDialog';
import DragablePaperComponent from '../../components/dialogs/DragablePaperComponent';
import AddToListButton from '../../components/buttons/AddToListButton';
import TabsDialogContainer from '../../components/dialogs/TabsDialogContainer';
import DeskRoundedIcon from '@mui/icons-material/DeskRounded';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import AddNextButtonTabHeader from '../../components/buttons/AddNextButtonTabHeader';
import SnackbarBasic from '../../components/notifications/SnackbarBasic';


function PagePlaces() {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const dispatch = useDispatch();
    const { t } = useTranslation();

    const isAboveMobileSize = useMediaQuery(settings.NON_MOBILE_MEDIA_QUERY);
    const writeAccess = usePermission(['places_write'])

    const activePlace = useSelector(getActivePlace);
    const placeDialogState = useSelector(getPlaceDialogState);
    const deleteState = useSelector(getPlaceDeleteState);


    const changeTab = (e, clickedTab) => {
        dispatch(setPlaceActiveTab(clickedTab));
    };

    const handleAddNewClick = () => {
        dispatch(startAddingPlace());
    };

    const handleClosePlaceDialog = () => {
        dispatch(closePlaceDialog());
    };

    const handleDelete = () => {
        dispatch(deletePlace(activePlace));
    };

    const handleCloseDeletingDialog = () => {
        dispatch(closeDeletingDialog());
    };


    return (
        <>

            {/* PAGE */}
            <Box display='flex' flexDirection='column'>
                <TableHeader
                    title={t('page.places')}
                    icon={<DeskRoundedIcon sx={{ color: colors.assigned.tableHeader, fontSize: '32px' }} />}
                >
                    <AddToListButton
                        text={t('button.add_new_place')}
                        onClick={handleAddNewClick}
                        permission={writeAccess}
                    />
                </TableHeader>
                <GridPlaces />
            </Box>
            <SnackbarBasic />

            {/* DIALOG */}
            <Dialog
                open={placeDialogState.isOpen}
                PaperComponent={DragablePaperComponent}
                PaperProps={{
                    sx: {
                        backgroundColor: colors.primary[500],
                        width: isAboveMobileSize ? { sm: settings.MIN_WIDTH_OF_SM_WIDTH_TAB, md: '600px' } : '95vw',
                        height: isAboveMobileSize ? '527px' : '527px', // set height order: --- 2/3 ---
                        m: "0px",
                        overflow: 'hidden'
                    }
                }}
            >
                <Box
                    display='flex'
                    flexDirection='column'
                    mx={isAboveMobileSize ? '20px' : '5px'}
                >
                    <TabContext value={placeDialogState.activeTab} >
                        <TabsDialogContainer
                            onClose={handleClosePlaceDialog}
                        >
                            <Box
                                display='flex'
                                width='100%'
                                justifyContent='space-between'
                                alignItems='center'
                            >
                                <TabList
                                    onChange={changeTab}
                                    textColor='secondary'
                                    indicatorColor='secondary'
                                >
                                    <Tab
                                        label={isAboveMobileSize ? t('tab.general') : null}
                                        icon={<DescriptionOutlinedIcon />}
                                        iconPosition="start"
                                        value="general"
                                        wrapped
                                    />
                                    <Tab
                                        label={isAboveMobileSize ? t('tab.attachments') : null}
                                        icon={<AttachFileIcon />}
                                        iconPosition="start"
                                        value="attachments"
                                        wrapped
                                        disabled={true}//{placeDialogState.mode === 'add'}
                                    />
                                </TabList>
                                <AddNextButtonTabHeader
                                    text={'Add Next'}
                                    onClick={handleAddNewClick}
                                />
                            </Box>
                        </TabsDialogContainer>
                        <Box
                            height={isAboveMobileSize ? '460px' : '460px'} // set height order: --- 1/3 ---
                            position='relative' // absolute position of the button group in tabs
                            sx={{
                                '& .MuiTabPanel-root': {
                                    px: '5px',
                                },
                            }}
                        >
                            <TabPanel value="general">
                                <FormPlace />
                            </TabPanel>
                            <TabPanel value="attachments">
                                {/* <AttachmentsTab /> */}
                            </TabPanel>
                        </Box>
                    </TabContext>
                </Box>
            </Dialog>

            {/* DELETE DIALOG */}
            <ConfirmActionDialog
                open={deleteState.dialog}
                onConfirm={handleDelete}
                onCancel={handleCloseDeletingDialog}
                confirmButtonLabel={t('button.delete')}
                message={t('notification.confirm_delete')}
                icon={<DeleteForeverOutlinedIcon sx={{ color: colors.redAccent[500], fontSize: '140px' }} />}
                status={deleteState.status}
                error={deleteState.error}
            />
        </>
    );
};

export default PagePlaces;